import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, ShieldCheck, CheckCircle2, ArrowRight } from 'lucide-react';
const eliteFeatures = [{
  title: 'Sumario por Abuso',
  desc: 'Cómo responder ante sumario por no haber detectado abuso infantil.',
  image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Denuncia por Diagnóstico',
  desc: 'Cómo responder ante denuncia por diagnóstico de TDAH o TEA cuestionado por los padres.',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Protocolo 48hs',
  desc: 'Protocolo de acción ante denuncia penal: los primeros 5 pasos en las primeras 48 horas.',
  image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Documentación Diaria',
  desc: 'Documentación preventiva diaria: 5 plantillas de alto valor legal específicas para pediatría.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Derivación Fallida',
  desc: 'Cómo documentar cuando derivaste y la familia no fue al especialista.',
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Auditoría Interna',
  desc: 'Checklist de auditoría interna mensual para pediatras.',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Plantillas Formales',
  desc: 'Plantillas de comunicaciones formales con juzgado de familia y organismos de protección.',
  image: 'https://images.unsplash.com/photo-1618044733300-9472054094ee?auto=format&fit=crop&w=600&h=400&q=80'
}, {
  title: 'Organismos de Apoyo',
  desc: 'Organismos de apoyo al médico denunciado en casos con menores en Argentina.',
  image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=600&h=400&q=80'
}];
export function EliteUpsell() {
  return <section className="bg-slate-50 py-12 sm:py-28 border-y border-slate-200 overflow-hidden" data-id="element-103">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="text-center mb-8 sm:mb-16" data-id="element-105">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-teal-600 uppercase mb-1.5 sm:mb-3" data-id="element-106">
            UPGRADE ELITE
          </h2>
          <p className="text-2xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-107">
            ¿Qué agrega el Blindaje Legal Pediátrico Total?
          </p>
          <p className="text-xs sm:text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-108">
            Para pediatras que no pueden permitirse perder la matrícula ante un
            caso de salud mental o abuso
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 mb-10 sm:mb-16 max-w-5xl mx-auto" data-id="element-109">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02
        }} className="bg-white rounded-2xl p-5 sm:p-8 shadow-sm ring-1 ring-slate-200 transition-all" data-id="element-110">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 text-slate-500 font-semibold text-sm sm:text-base" data-id="element-111">
              <ShieldAlert className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-112" />
              <h3 data-id="element-113">Sin Elite</h3>
            </div>
            <p className="text-xs sm:text-base text-slate-600 leading-relaxed" data-id="element-114">
              Si te denuncian por no haber detectado un abuso, por un
              diagnóstico cuestionado o por una derivación tardía, no sabés qué
              hacer en las primeras 48 horas. Sin sistema preventivo que
              construya tu escudo legal consulta a consulta.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02
        }} className="bg-teal-50 rounded-2xl p-5 sm:p-8 shadow-md ring-1 ring-teal-300 transition-all" data-id="element-115">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 text-teal-700 font-semibold text-sm sm:text-base" data-id="element-116">
              <ShieldCheck className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-117" />
              <h3 data-id="element-118">Con Elite</h3>
            </div>
            <p className="text-xs sm:text-base text-teal-900 leading-relaxed" data-id="element-119">
              Sistema completo de protección legal específico para pediatría:
              descargo ante sumario por caso de salud mental o abuso, protocolo
              ante denuncia penal, documentación preventiva diaria y plantillas
              formales para cada situación institucional con menores.
            </p>
          </motion.div>
        </div>

        <div className="bg-slate-900 rounded-3xl shadow-xl overflow-hidden" data-id="element-120">
          <div className="px-6 py-8 sm:p-12 text-center border-b border-slate-800" data-id="element-121">
            <h3 className="text-xs sm:text-sm font-semibold tracking-wide text-teal-400 uppercase mb-2" data-id="element-122">
              EL ELITE INCLUYE
            </h3>
            <p className="text-xl sm:text-3xl font-bold text-white" data-id="element-123">
              Blindaje Legal Pediátrico Total
            </p>
            <p className="text-slate-400 mt-2 text-sm sm:text-lg" data-id="element-124">
              50 páginas premium de protección absoluta
            </p>
          </div>

          <div className="p-6 sm:p-10 bg-slate-800/50" data-id="element-125">
            <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-6 -mx-6 px-6 sm:mx-0 sm:px-0 hide-scrollbar" data-id="element-126">
              {eliteFeatures.map((feature, index) => <motion.div key={index} whileHover={{
              y: -5
            }} className="min-w-[260px] sm:min-w-[300px] snap-center bg-slate-800 rounded-2xl overflow-hidden ring-1 ring-slate-700 flex flex-col group cursor-pointer" data-id="element-127">
                  <div className="h-32 sm:h-40 overflow-hidden relative" data-id="element-128">
                    <img src={feature.image} alt={feature.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 opacity-80 group-hover:opacity-100" data-id="element-129" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent" data-id="element-130"></div>
                    <div className="absolute bottom-3 left-4 flex items-center gap-2" data-id="element-131">
                      <CheckCircle2 className="w-4 h-4 text-teal-400" data-id="element-132" />
                      <span className="text-white font-semibold text-sm" data-id="element-133">
                        {feature.title}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 sm:p-5 flex-grow flex flex-col" data-id="element-134">
                    <p className="text-xs sm:text-sm text-slate-300 leading-relaxed flex-grow" data-id="element-135">
                      {feature.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
            <div className="text-center mt-2 sm:hidden text-[10px] font-medium text-slate-500 flex items-center justify-center gap-1.5" data-id="element-136">
              <span data-id="element-137">←</span> Deslizá para explorar <span data-id="element-138">→</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}